const Main = () => import(/* webpackChunkName: "autorizacao-bundle" */'./main.vue');
const Search = () => import(/* webpackChunkName: "autorizacao-bundle" */'./search.vue');

export default [
  {
    name: 'guias-administrativas',
    path: '/guias-administrativas',
    components: { default: Main, search: Search },
    meta: {
      requiresAuth: true,
      breadcrum: 'Guias Administrativas',
      icon: 'clipboard-check',
      can: 'list',
      on: 'guiaadministrativa',
      neto: true,
      client: 'aeco',
    },
  },
];
